import { Box, Button, Flex, Group, Select, Switch, Text, TextInput } from "@mantine/core";
import React, { useEffect, useState } from "react";
import { getListApplication } from "../../../services/application";
import FormSkeleton from "../../ui/FormSkeleton";
import { getListOrganization } from "../../../services/organization";
import { addDatabaseApp, updateDatabaseApp } from "../../../services/databaseApp";
import { validation } from "../../../plugins/validation";
import { notificationError, notificationSuccess } from "../../ui/Notification";

const defaultVal = {
  name: "",
  isActive: false,
  applicationId: "",
  organizationId: "",
  urlFrontend: "",
  urlBackend: "",
};

const formValidation = {
  name: {
    isError: false,
    message: "",
  },
  isActive: {
    isError: false,
    message: "",
  },
  applicationId: {
    isError: false,
    message: "",
  },
  organizationId: {
    isError: false,
    message: "",
  },
  urlFrontend: {
    isError: false,
    message: "",
  },
  urlBackend: {
    isError: false,
    message: "",
  },
};

const paramOrganization = {
  skip: 0,
  take: 100,
  keyword: "",
  orderBy: "name",
};

const FormDatabseApp = ({ onCloseModal, dataDatabaseApplication, reloadList }) => {
  const [loading, setLoading] = useState(false);
  const [loadingForm, setLoadingForm] = useState(false);
  const [formData, setFormData] = useState(defaultVal);
  const [validationForm, setValidationForm] = useState(formValidation);
  const [selectedApplicationId, setSelectedApplicationId] = useState([]);
  const [applicationList, setApplicationList] = useState([]);
  const [selectedOrganizationId, setSelectedOrganizationId] = useState([]);
  const [organizationList, setOrganizationList] = useState([]);
  console.log(dataDatabaseApplication);
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSwitch = () => {
    setFormData({ ...formData, isActive: !formData.isActive });
  };

  const handleGetListApplication = async () => {
    setLoadingForm(true);
    try {
      const response = await getListApplication();
      const dataApplication = response.data;
      const mappingApplication = [
        { value: "", label: "Select aplikasi" },
        ...dataApplication.map((val) => ({
          value: val?.id?.toString(),
          label: val?.name,
        })),
      ];
      setApplicationList(mappingApplication);
    } catch (error) {
      console.log(error);
    }
    setLoadingForm(false);
  };

  const handleGetListOrganization = async () => {
    setLoadingForm(true);
    try {
      const response = await getListOrganization(paramOrganization);
      const dataOrganization = response.data;
      const mappingOrganization = [
        { value: "", label: "Select organisasi" },
        ...dataOrganization.map((val) => ({
          value: val?.id?.toString(),
          label: val?.name,
        })),
      ];
      setOrganizationList(mappingOrganization);
    } catch (error) {
      console.log(error);
    }
    setLoadingForm(false);
  };

  useEffect(() => {
    handleGetListApplication();
    handleGetListOrganization();
    // eslint-disable-next-line
  }, [selectedApplicationId, selectedOrganizationId]);

  useEffect(() => {
    handleGetListApplication();
    handleGetListOrganization();
    if (dataDatabaseApplication !== null) {
      handleSetForm(dataDatabaseApplication);
    }
    // eslint-disable-next-line
  }, [dataDatabaseApplication]);

  const handleSetForm = (dataDatabaseApplication) => {
    const dataDetail = {
      name: dataDatabaseApplication?.name,
      urlFrontend: dataDatabaseApplication?.urlFrontend,
      urlBackend: dataDatabaseApplication?.urlBackend,
      isActive: dataDatabaseApplication?.isActive,
      applicationId: selectedApplicationId,
      organizationId: selectedOrganizationId,
    };
    setSelectedApplicationId(dataDatabaseApplication?.application?.id);
    setSelectedOrganizationId(dataDatabaseApplication?.organization?.id);
    setFormData(dataDetail);
  };

  const handleSubmit = async (data) => {
    let methodFunction = null;
    let titleMessageSuccess = "";
    let captionMessageSuccess = "";
    let titleMessageError = "";
    let captionMessageError = "";
    setLoading(true);
    setValidationForm(formValidation);
    const payload = {
      name: data.name,
      urlFrontend: data.urlFrontend,
      urlBackend: data.urlBackend,
      isActive: Boolean(data.isActive),
      applicationId: selectedApplicationId,
      organizationId: selectedOrganizationId,
    };
    const isError = validation(payload, setValidationForm);
    if (isError) {
      setLoading(false);
      return;
    }
    if (dataDatabaseApplication !== null) {
      methodFunction = updateDatabaseApp(dataDatabaseApplication?.id, payload);
      titleMessageSuccess = "Update Database App Berhasil";
      captionMessageSuccess = "Anda telah berhasil mengupdate data Database App";
      titleMessageError = "Gagal Mengupdate Database App";
      captionMessageError = "Silahkan cek kembali form anda";
    } else {
      methodFunction = addDatabaseApp(payload);
      titleMessageSuccess = "Tambah Database App Berhasil";
      captionMessageSuccess = "Anda telah berhasil menambahkan Database App baru";
      titleMessageError = "Gagal Menambahkan Database App";
      captionMessageError = "Silahkan cek kembali form anda";
    }
    try {
      const response = await methodFunction;
      if (response) {
        onCloseModal();
        reloadList();
        notificationSuccess(titleMessageSuccess, captionMessageSuccess);
      }
    } catch (error) {
      const errorMessage = error.response.data.message;
      notificationError(titleMessageError, `${Object.keys(errorMessage) ? errorMessage : captionMessageError}`);
      Object.values(errorMessage).forEach((el) => {
        Object.keys(formValidation).forEach((element) => {
          if (el.includes(element)) {
            setValidationForm((old) => ({
              ...old,
              [element]: {
                ...old?.[element],
                isError: true,
                message: el,
              },
            }));
          }
        });
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      {!loadingForm ? (
        <>
          {" "}
          <Box mb="md">
            <Select
              name="applicationId"
              label="Aplikasi"
              placeholder="Pilih aplikasi"
              searchable
              nothingFoundMessage="Aplikasi tidak ditemukan"
              data={applicationList}
              onChange={(e) => setSelectedApplicationId(e)}
              error={validationForm?.applicationId?.isError ? `${validationForm?.applicationId?.message}` : ""}
              value={selectedApplicationId}
              withAsterisk
            />
          </Box>
          <Box mb="md">
            <Select
              name="organizationId"
              label="Organisasi"
              placeholder="Pilih organisasi"
              searchable
              nothingFoundMessage="Organisasi tidak ditemukan"
              data={organizationList}
              onChange={(e) => setSelectedOrganizationId(e)}
              error={validationForm?.organizationId?.isError ? `${validationForm?.organizationId?.message}` : ""}
              value={selectedOrganizationId}
              withAsterisk
            />
          </Box>
          <Box mb="md">
            <TextInput name="name" value={formData.name} label="Name" placeholder="Masukkan nama database" error={validationForm.name.isError ? `${validationForm.name.message}` : ""} onChange={handleChange} withAsterisk />
          </Box>
          <Box mb="md">
            <TextInput
              name="urlFrontend"
              value={formData.urlFrontend}
              label="URL Frontend"
              placeholder="Masukkan URL Frontend"
              error={validationForm.urlFrontend.isError ? `${validationForm.urlFrontend.message}` : ""}
              onChange={handleChange}
              withAsterisk
            />
          </Box>
          <Box mb="md">
            <TextInput
              name="urlBackend"
              value={formData.urlBackend}
              label="URL Backend"
              placeholder="Masukkan URL Backend"
              error={validationForm.urlBackend.isError ? `${validationForm.urlBackend.message}` : ""}
              onChange={handleChange}
              withAsterisk
            />
          </Box>
          <Box mb="md">
            <Flex justify="flex-start">
              <Text fz={14} mx={3} mr={8}>
                Active :{" "}
              </Text>
              <Text fz={14} mx={3} mr={8} c="red">
                {validationForm?.isActive?.isError ? `${validationForm?.isActive?.message}` : ""}
              </Text>
              <Switch onLabel="YES" offLabel="NO" checked={formData.isActive} onChange={handleSwitch} />
            </Flex>
          </Box>
        </>
      ) : (
        <Box>
          <FormSkeleton total={3} />
        </Box>
      )}
      <Box mt={20}>
        <Flex justify="flex-end">
          <Group>
            <Button variant="outline" color="indigo.9" onClick={onCloseModal}>
              Tutup
            </Button>
            <Button loading={loading} variant="filled" color="indigo.9" onClick={() => handleSubmit(formData)}>
              Simpan
            </Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  );
};

export default FormDatabseApp;
